import { useEffect } from 'react';

const SUFFIX = ' | PlantaDay';
const DEFAULT_PARENT_TITLE = 'PlantADay - Garden Design Platform';

/**
 * Sets document.title for garden routes so the tab / PWA chrome does not
 * show raw URL segments (e.g. UUIDs). Restores the default on unmount.
 * @param {string} [title] — Short page label (without suffix). Falsy uses fallback.
 * @param {string} [fallback] — When title is empty while loading, e.g. "Plant"
 */
export function useGardenPageTitle(title, fallback = 'Garden') {
  const t = (title && String(title).trim()) || fallback;

  useEffect(() => {
    document.title = `${t}${SUFFIX}`;
    return () => {
      document.title = DEFAULT_PARENT_TITLE;
    };
  }, [t]);
}
